import React from 'react'
import styled from 'styled-components'
import { down } from 'styled-breakpoints'
import responsiveStyle from '../../styles/responsiveStyle'
import { ReactComponent as TrafficLight } from '../../assets/svg/traffic-light.svg'
import { ReactComponent as Helmet } from '../../assets/svg/helmet.svg'
import { ReactComponent as Kickboard } from '../../assets/svg/kickboard.svg'
import { TABLET } from '../../lib/constant'

const features = [
	{
		id: 1,
		title: '매직라이더',
		description:
			'가장 가까운 타고가 스쿠터를 바로 검색해줍니다. 혹은 배터리 상태를 고려하여 바로 찾기때문에 시간을 절약할 수 있습니다.',
		icon: <TrafficLight />,
	},
	{
		id: 2,
		title: '퀵, 리턴',
		description:
			'반납에 대해서 오래걸리지 않아요. 바로 그리고 편하게 반납으로 시간을 절약하세요.',
		icon: <Kickboard />,
	},
	{
		id: 3,
		title: '즐기는 라이딩',
		description:
			'이제 타고가를 안전하게 즐기시면 됩니다. 안전수칙을 지키면서 자유롭게 도시를 라이딩해보세요.',
		icon: <Helmet />,
	},
]

export default function FeaturesSection() {
	return (
		<Section>
			<Title>
				시작부터 반납까지 <br /> 쉽고, 즐겁게
			</Title>
			<ul>
				{features.map((item) => (
					<FeatureItem key={item.id}>
						<IconBlock>{item.icon}</IconBlock>
						<ContentBlock>
							<h5>{item.title}</h5>
							<p>{item.description}</p>
						</ContentBlock>
					</FeatureItem>
				))}
			</ul>
		</Section>
	)
}

const Section = styled.section`
	${responsiveStyle}
	max-width: 780px;
	padding: 0 16px;
	margin-top: 196px;
`

const Title = styled.h3`
	font-size: 64px;
	line-height: 72px;
	font-weight: 700;
	margin-bottom: 48px;

	${down(TABLET)} {
		font-size: 40px;
		line-height: 48px;
		margin-bottom: 32px;
	}
`

const FeatureItem = styled.li`
	display: flex;
	justify-content: space-between;
	align-items: center;

	& + & {
		margin-top: 48px;
	}

	${down(TABLET)} {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		& + & {
			margin-top: 32px;
		}
	}
`

const IconBlock = styled.div`
	width: 180px;
	height: 196px;
	margin-right: 48px;
	svg {
		width: 100%;
		height: 100%;
	}

	${down(TABLET)} {
		width: 80px;
		height: 80px;
		margin-bottom: 16px;
	}
`

const ContentBlock = styled.div`
	max-width: 579px;
	width: 100%;

	> h5 {
		font-size: 32px;
		line-height: 40px;
		font-weight: 700;
	}

	> p {
		margin-top: 16px;
		font-size: 20px;
		line-height: 32px;
	}

	${down(TABLET)} {
		> h5 {
			font-size: 24px;
			line-height: 32px;
		}
		> p {
			font-size: 16px;
			line-height: 24px;
		}
	}
`
